<ng-container [formGroup]="parentForm">
  <ion-label class="required">{{
    "Is HPV vaccination given Previously?" | translate
  }}</ion-label>
  <div class="ion-margin-vertical">
    <mat-radio-group
      formControlName="is_hpv_vaccinated"
      aria-label="Select an option"
      (click)="isHPVVaccinated()"
    >
      <mat-radio-button color="primary" [value]="true">{{
        "Yes" | translate
      }}</mat-radio-button>
      <mat-radio-button color="primary" [value]="false">{{
        "No" | translate
      }}</mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- <ion-checkbox
    formControlName="is_hpv_vaccinated"
    (click)="isHPVVaccinated()"
    >{{ "Is HPV Vaccinated" | translate }}</ion-checkbox
  > -->
  <ng-container *ngIf="parentForm.get('is_hpv_vaccinated').value === true">
    <app-ion-custom-datepicker
      [class]="'noclass'"
      style="width: 100%"
      [label]="'Last Date of Vaccination' | translate"
      formKey="hpv_vaccination_date"
      [parentForm]="parentForm"
      placeholder="DD/MM/YYYY"
      [minDate]="hpvMinVaccinatedDate"
      [maxDate]="hpvMaxVaccinatedDate"
    >
    </app-ion-custom-datepicker>
    <ion-label class="required">{{ "Vaccine Name" | translate }}</ion-label>
    <mat-form-field
      appearance="outline"
      class="ion-margin-vertical matDropdown"
    >
      <mat-select
        [placeholder]="'Select from the list' | translate"
        formControlName="hpv_material_id"
      >
        <mat-option
          *ngFor="let m of allMaterialsStore.allMaterials()"
          [value]="m.material_id"
          >{{ m.material_name }}</mat-option
        >
        <mat-option value="other">{{ "Other" | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ion-label
      *ngIf="parentForm?.controls?.hpv_material_id.value === 'other'"
      >{{ "Vaccine name other" }}</ion-label
    >
    <ion-item
      class="item-border ion-no-padding"
      lines="none"
      *ngIf="parentForm?.controls?.hpv_material_id.value === 'other'"
    >
      <ion-input
        matInput
        errorText=" "
        type="text"
        maxlength="30"
        formControlName="hpv_material_other"
      ></ion-input>
    </ion-item>
    <ion-label class="required">{{ "Vaccinated At" | translate }}</ion-label>
    <div class="ion-margin-vertical">
      <mat-radio-group
        formControlName="hpv_vaccinated_at_public"
        aria-label="Select an option"
      >
        <mat-radio-button color="primary" value="Govt">{{
          "Govt" | translate
        }}</mat-radio-button>
        <mat-radio-button color="primary" value="Private">{{
          "Private" | translate
        }}</mat-radio-button>
      </mat-radio-group>
    </div>
  </ng-container>
</ng-container>
